import { HttpError } from "../../http-error";
import * as t from "io-ts";
import { ErrorResponse, ErrorResponseOutput } from "../error-response";
import { BadResponseBodyError } from "../../bad-response-body-error";
import { User } from "../user";
import { PlainPassword } from "../../types/user/password";

export const SignInRequest = t.type({
  email: t.string,
  password: PlainPassword,
});
export type SignInRequest = t.TypeOf<typeof SignInRequest>;

export const SignInResponse = t.type({
  user: User
});
export type SignInResponse = t.TypeOf<typeof SignInResponse>;
export type SignInResponseOutput = t.OutputOf<typeof SignInResponse> | ErrorResponseOutput;

export async function signIn(body: SignInRequest) {
  return fetch("/api/auth/signin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(SignInRequest.encode(body)),
  }).then(async (res) => {
    if (res.status === 403) {
      const json = BadResponseBodyError.throwIfLeft(res.status, 
        ErrorResponse.decode(await res.json()));
      throw new HttpError(403, json.message || "Not authorized!");
    } else {
      const user = BadResponseBodyError.throwIfLeft(res.status,
        SignInResponse.decode(await res.json()));
      return user;
    }
  });
}